import type { JobApplicationDTO, JobPostingDTO, Position, PositionDTO } from "@pentacode/core";
import { Contract, Employee, Salary, toDateString } from "@pentacode/core";
import type { Hours } from "@pentacode/openapi";
import { app } from "../init";

export function getPostingPositions(posting: JobPostingDTO): Position[] {
    return (posting.positions ?? []).flatMap((position: PositionDTO) => {
        if (!position?.id) {
            return [];
        }

        const resolvedPosition = app.getPosition(position.id)?.position;
        return resolvedPosition ? [resolvedPosition] : [];
    });
}

export function buildEmployeeDraftFromApplication(application: JobApplicationDTO, posting: JobPostingDTO): Employee {
    return new Employee({
        firstName: application.firstName,
        lastName: application.lastName,
        avatar: application.headShotUrl,
        birthday: application.birthday || undefined,
        address: application.address,
        postalCode: application.postalCode,
        city: application.city,
        email: application.email,
        phone: application.phone,
        positions: getPostingPositions(posting),
        contracts: [
            new Contract({
                start: posting.start || toDateString(new Date()),
                end: posting.end,
                hoursPerWeek: posting.hoursPerWeek || (0 as Hours),
                employmentType: posting.employmentType,
                salaries: [
                    new Salary({
                        type: posting.payType,
                        amount: posting.payAmount,
                        positionId: null,
                    }),
                ],
            }),
        ],
    });
}

export async function rejectApplication(applicationId: number) {
    await app.api.rejectJobApplication({ applicationId, sendEmail: true });
}

export async function acceptApplication(applicationId: number, employeeId: number) {
    await app.api.acceptJobApplication({ applicationId, employeeId });
}
